import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined"
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined"

import { STOCK_TYPES } from "../../utils/stockTypes"

/** The two fridges, named and coloured once so every screen shows the same thing. */
export const FRIDGES = {
	[STOCK_TYPES.LIBRE_SERVICE]: {
		id: STOCK_TYPES.LIBRE_SERVICE,
		label: "Frigo libre-service",
		shortLabel: "Libre-service",
		transferLabel: "libre-service",
		Icon: StorefrontOutlinedIcon,
		color: "#2E7D45",
		background: "#EAF6EC"
	},
	[STOCK_TYPES.CLICK_AND_COLLECT]: {
		id: STOCK_TYPES.CLICK_AND_COLLECT,
		label: "Frigo click & collect",
		shortLabel: "Click & collect",
		transferLabel: "click & collect",
		Icon: ShoppingBagOutlinedIcon,
		color: "#B45309",
		background: "#FCF0DF"
	}
}

/** Self-service first, as the prototype orders them. */
export const FRIDGE_ORDER = [STOCK_TYPES.LIBRE_SERVICE, STOCK_TYPES.CLICK_AND_COLLECT]
